import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component({
    data() {
        return {
            opened: false
        };
    }
})
export default class DeclineModal extends Vue {
    @Prop(Boolean)
    value: boolean;

    @Prop(Number)
    eventId: number;

    opened: boolean;

    @Watch('value')
    onChangeValue(value: boolean) {
        this.opened = value;
    }

   @Watch('opened')
    onChangeOpened(value) {
        this.$emit('input', value);
    }

   close() {
       this.opened = false;

       this.$emit('close');
   }
}
